module.exports = __webpack_public_path__ + "static/media/businesswoman-wiping-hands-7VXE7PL1.dd9d8424.png";